module.exports = __webpack_public_path__ + "media/recipes/69-fae26c83.png";